import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgMotorbike = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 49 49", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#Motorbike_svg__a)", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.55,
        d: "M33.673 11.469a3.8 3.8 0 0 0-2.838-1.268H19.167c-1.126 0-2.14.49-2.838 1.268-.752.838-1.053 1.99-.89 3.106l.07.461c.04.28.281.486.563.486h4.053v2.332a2.989 2.989 0 0 0 2.988 2.989h-1.181a3.58 3.58 0 0 0-3.581 3.58v8.58a3.58 3.58 0 0 0 3.58 3.581h6.142a3.58 3.58 0 0 0 3.58-3.58v-8.58a3.58 3.58 0 0 0-3.58-3.581H26.89a2.989 2.989 0 0 0 2.989-2.989v-2.332h4.053a.57.57 0 0 0 .563-.486l.069-.461c.164-1.115-.138-2.266-.89-3.106h-.002Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.65,
        d: "M25 13.305a4.878 4.878 0 1 0 0-9.755 4.878 4.878 0 0 0 0 9.755Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.85,
        d: "M25 11.975a3.547 3.547 0 1 0 0-7.095 3.547 3.547 0 0 0 0 7.095ZM28.326 28.936a3.326 3.326 0 1 0-6.652 0v15.74a3.326 3.326 0 1 0 6.652 0v-15.74Z",
        fill: "#65BFF1"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.174 8.52h-16.35a2.748 2.748 0 0 1-2.745-2.744V4.734a1.41 1.41 0 0 0-1.41-1.41H2.995a.777.777 0 0 1 0-1.553h9.676a2.966 2.966 0 0 1 2.962 2.963v1.042c0 .658.534 1.192 1.193 1.192h16.35c.657 0 1.193-.534 1.193-1.192V4.734a2.966 2.966 0 0 1 2.962-2.963h9.676a.777.777 0 0 1 0 1.552h-9.675a1.41 1.41 0 0 0-1.41 1.41v1.043a2.747 2.747 0 0 1-2.745 2.744h-.003Z",
        fill: "#65BFF1",
        opacity: 0.55
      }
    ),
    /* @__PURE__ */ jsx("g", { opacity: 0.65, fill: "#65BFF1", children: /* @__PURE__ */ jsx("path", { d: "M2.552 1h5.266c.153 0 .277.124.277.277v2.548a.277.277 0 0 1-.277.277H2.552a1.55 1.55 0 1 1 0-3.102ZM47.448 4.104h-5.266a.277.277 0 0 1-.277-.277V1.279c0-.153.124-.277.277-.277h5.266c.856 0 1.552.696 1.552 1.552 0 .854-.696 1.55-1.552 1.55Z" }) }),
    /* @__PURE__ */ jsx("g", { opacity: 0.75, fill: "#65BFF1", children: /* @__PURE__ */ jsx("path", { d: "M15.356 35.586H9.59a.998.998 0 0 0 0 1.996h5.765a.998.998 0 0 0 0-1.996ZM34.644 37.582h5.765a.998.998 0 1 0 0-1.995h-5.765a.998.998 0 1 0 0 1.995Z" }) }),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.65,
        d: "M34.37 36.03h-2.422a.178.178 0 0 1-.177-.197l2.093-20.085a1.108 1.108 0 1 0-2.206-.228l-2.12 20.353a.178.178 0 0 1-.177.16h-8.72a.178.178 0 0 1-.177-.16l-2.12-20.353a1.108 1.108 0 1 0-2.206.228l2.093 20.085a.179.179 0 0 1-.177.197h-2.421a.386.386 0 0 0-.386.386v1.366c0 .623.505 1.128 1.128 1.128h17.252c.623 0 1.128-.505 1.128-1.128v-1.366a.386.386 0 0 0-.386-.386Z",
        fill: "#65BFF1"
      }
    )
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "Motorbike_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", transform: "translate(1 1)", d: "M0 0h48v47.002H0z" }) }) })
] });
const ForwardRef = forwardRef(SvgMotorbike);
export {
  ForwardRef as default
};
